mainApp.component('ikeV2TestConnection', {
    templateUrl: '/public/components/IkeV2TestConnection.html',
    bindings: {
        siteId: '=',
        hasChanges: '='
    },
    controller: ikeV2TestConnectionCtrl
});


/**
 * Created by ronmarsiano on 09/07/2018.
 */
function ikeV2TestConnectionCtrl($scope,$state,$timeout) {
    var ctrl = this;

    ctrl.getConnectionStatus = function() {
        store.fetch({
            path: '/testSiteIkeV2Connection',
            queryParams: { accountId: $state.params.accountId, siteId: ctrl.siteId},
            success: function (data) {
                if(data && data.status && data.status == "ERROR"){
                    $scope.$root.errors['ikeV2TestConnection'] = 'Could not test connection';
                }
                else{
                    delete $scope.$root.errors['ikeV2TestConnection'];
                    data.forEach(function (connectionStatus) {
                        ctrl.parseTimeProperties(connectionStatus);
                    });
                    ctrl.connectionStatus = data;
                    /*
                     * we use timeout here since we want angular to iterate a
                     * digest cycle so screen weill be loaded fully
                    */
                    $timeout(function() {
                        $scope.$root.openPopup('connectionDetailsIkeV2');
                    });
                }
            }
        });
    };

    /**
     * object ConnectionStatusTime which manipulate the recived time
     * we get it on UTC in the following format "DD/MM/YY hh:mm:ss.SSS" e.g. "04/07/18 12:25:54.039"
     * we evaluate of the time has passed end setting a string to properly display the time
     * @param time
     * @constructor
     */
    function ConnectionStatusTime(time) {
        var now = new Date ();
        // in UTC
        var statusTime =  (moment.utc(time,"DD/MM/YY hh:mm:ss.SSS")).toDate();
        //Removing the GMT ending
        var statusTimeStr = statusTime.toUTCString().split(' ').slice(0,5).join(' ');
        // printing in UTC format
        this.toString = statusTimeStr + ' UTC';
        this.hasPassed = statusTime < now;
    }

    /**
     * parsing all time related properties into the received connection status
     * @param connectionStatus
     */
    ctrl.parseTimeProperties = function(connectionStatus){
        if(connectionStatus){
            if(connectionStatus.Connection_IKE_SAs){
                connectionStatus.Connection_IKE_SAs.forEach(function (connectionIkeSa) {
                    if(connectionIkeSa){
                        if(connectionIkeSa.established_timestamp){
                            connectionIkeSa.established_timestamp = new ConnectionStatusTime(connectionIkeSa.established_timestamp);
                        }
                        if(connectionIkeSa.expiration_timestamp){
                            connectionIkeSa.expiration_timestamp = new ConnectionStatusTime(connectionIkeSa.expiration_timestamp);
                        }
                    }
                })
            }
            if(connectionStatus.Connection_ESP_SAs){
                connectionStatus.Connection_ESP_SAs.forEach(function (connectionESPSa) {
                    if(connectionESPSa){
                        if(connectionESPSa.established_timestamp){
                            connectionESPSa.established_timestamp = new ConnectionStatusTime(connectionESPSa.established_timestamp);
                        }
                        if(connectionESPSa.expiration_timestamp){
                            connectionESPSa.expiration_timestamp = new ConnectionStatusTime(connectionESPSa.expiration_timestamp);
                        }
                    }
                });
            }
        }
    };

    /**
     * closing the test connection pop up
     */
    ctrl.closeTestConnectionPopUp = function () {
        $scope.$root.closePopup('connectionDetailsIkeV2');
    };
};

